// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"121":"program","278":"cookies","535":"login","631":"contact"}[chunkId] + "." + {"121":"06c76d1d","278":"4c0a9dc7","535":"7edd84ff","631":"a3d741c8"}[chunkId] + ".css";
};